/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 * @author Nikolay Sviridov
 * @version 1.35.0
 * @since 1.35.0
 */

import styled from 'styled-components';

import { colors } from '@theme/index';

export const DividerHr = styled.hr`
	margin: 0;
	color: ${colors.borderColorLight};
	opacity: 0.3;
`;

export const DividerVr = styled.div`
	height: 100%;
	opacity: 0.3;
	border-left: var(--card-border);
`;
